module.exports = __webpack_public_path__ + "static/media/visa.d2eb00b7.png";